import { Vue, Component, Prop } from 'vue-property-decorator';
import './index.scss';

@Component
export class LoadingTextUI extends Vue {
  @Prop({ default: false }) value;
  @Prop({ default: 1 }) type;
  @Prop({ default: 'Loading' }) text;
  @Prop({ default: '...' }) postfix;
  @Prop({ default: '100%' }) height;


  render(createElement) {
    return (
      <div class="loading-text-ui ut-colcen ut-text-secondary" style={{
        height: this.height
      }}>

        <div class="ut-rowcen">
          <div style={{
            marginRight: '4px'
          }}>
            {this.text} {this.postfix}
          </div>
          <img src="static/icons/loading.gif" alt="" />
        </div>
      </div>
    )
  }
}


/**
 * @returns {Vue.Component} vue
 */
export const LoadingHelper = () => {
  return {
    data() {
      return {
        loading: false,
        loadingText: false,
      }
    }
  }
}